import UPMfaOverrideDropdown from './UPMfaOverrideDropdown';
import { UPMfaOverrideDropdownProps } from './types';

export type { UPMfaOverrideDropdownProps };

export default UPMfaOverrideDropdown;
